module.exports = __webpack_public_path__ + "static/media/Facebook_Button@3x.51d1d453.png";